export default __webpack_public_path__ + "static/media/salao.f255b345.png";